import {
  Backdrop,
  Box,
  CircularProgress,
  createTheme,
  IconButton,
  ThemeProvider,
  Tooltip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useContext, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { DataContext } from ".";
import { jobGrade } from "../../data/jobGradeData";
import ComponentBackdrop from "../../components/backdrop";
import { pointEarnData } from "../../data/pointEarnData";
import CustomTheme from "../../theme/customTheme";
import { Visibility } from "@mui/icons-material";

const Listing = ({ handleShowButton, dataList }) => {
  const rows = dataList;
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const handleClose = () => {
    setOpenBackdrop(false);
  };
  const navigate = useNavigate();

  const navigateDetails = (id) => {
    navigate(`/view-employee/${id}`);
  }
  const columns = [
    {
      field: "Actions",
      headerName: "Action",
      width: 100,
      type: "actions",
      hideable: false,
      getActions: (params) => [
        <IconButton
          sx={{ color: "#39493F" }}
          onClick={() => navigateDetails(params.row.id)} // 👈 navigate with row id
        >
          <Tooltip title="View" placement="right">
            <Visibility />
          </Tooltip>
        </IconButton>,
      ],
    },
    {
      field: "id",
      headerName: "ID",
      width: 80,
      // renderCell: (params) => {
      //   return (
      //     <Link
      //       to={`/view-employee/${params.value}`}
      //       style={{ fontWeight: "bold", color: "black" }}
      //     >
      //       {params.value}
      //     </Link>
      //   );
      // },
    },
    {
      field: "EmpCode",
      headerName: "Employee Code",
      width: 150,
    },
    {
      field: "FullName",
      headerName: "Full Name",
      width: 150,
      flex: 1,
    },
    {
      field: "EarnedPoints",
      headerName: "Earned Points",
      width: 150,
      flex: 1,
    },
  ];
  return (
    <Box
      m="8px 0 0 0"
      style={{
        width: "100%",
        height:
          rows.length === 0
            ? "auto" // no height when no data
            : rows.length < 10
              ? "fit-content" // small data -> auto height
              : 600, // many rows -> fixed height
        overflowY: rows.length > 10 ? "auto" : "visible", // scroll if too many
      }}
    >
      <ComponentBackdrop open={openBackdrop} />
      {/* <ThemeProvider theme={CustomTheme}> */}
      <DataGrid
        columns={columns}
        rows={rows}
        showToolbar
        pageSizeOptions={[5, 10, { value: 50, label: "50" }]}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 10 },
          },
          columns: {
              columnVisibilityModel: {
                id: false, // hide ID column by default
              },
            },
        }}
        slotProps={{
          loadingOverlay: {
            variant: "linear-progress",
            noRowsVariant: "skeleton",
          },
          disableToolbarButton: {
            csvOptions: "true",
            printOptions: "true",
          },
          toolbar: {
            printOptions: { disableToolbarButton: true },
            csvOptions: { disableToolbarButton: true }
          },
        }}
        // checkboxSelection
        // onRowSelectionModelChange={(id) => {
        //   onSelectedCheckbox(id, rows);
        // }}
        disableRowSelectionOnClick
        localeText={{ noRowsLabel: "No records found" }}
      />
      {/* </ThemeProvider> */}
    </Box>
  );
};

export default Listing;
